// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

type WithDisplay = { data?: { display?: { data?: unknown } | null } | null };

// Accepts JSON-RPC object responses and kiosk items alike; both nest display under data.display.
export const hasDisplayData = (obj: WithDisplay) => !!obj.data?.display?.data;

/**
 * Display fields are typed `unknown` (Display V2 values can be structured JSON), but the
 * explorer only renders string values; anything else is treated as absent.
 */
export function getDisplayString(
	display: Record<string, unknown> | null | undefined,
	key: string,
): string | undefined {
	const value = display?.[key];
	return typeof value === 'string' ? value : undefined;
}
